<div class="rd-widget table-widget widget-{{widgetConfig?.widgetId}}" *ngIf="widgetData">
  <table class="widgetMarketLeasingAssumptionsClass widget-large cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <dynamic-growth-row [row]="1" [widget]="this">
        <tr class="widget-ruller-flex">
          <th scope="col" colspan="65" class="widget-grid-column widget-header-red" style="text-align: start;">
            <widget-value class="widget-header-red" [align]="'left'" [color]="'white'" [bold]="true">Market Leasing Assumption</widget-value>
          </th>
        </tr>
      </dynamic-growth-row>
      <dynamic-growth-row [row]="2" [widget]="this">
        <tr class="dark-grey-line">
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelSpaceType' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelSF' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelMarketRent' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelMeasure' | rdTranslate}}
          </th>
          <th scope="col" colspan="5">
            {{'marketLeasingAssumptions.labelRentEscalations' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelLeaseType' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelLeaseTermMos' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelFreeRentMos' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelEffectiveRent' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelTiSFShell' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelTiSFNew' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelTiSFRenew' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelRenewalProbability' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelLCNew' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelLCRenewal' | rdTranslate}}
          </th>
          <th scope="col" colspan="4">
            {{'marketLeasingAssumptions.labelMonthsDowntime' | rdTranslate}}
          </th>
        </tr>
      </dynamic-growth-row>
    </thead>
    <tbody class="extraTbody">

      <ng-container *ngFor="let entry of widgetData.rows; let i = index">
        <dynamic-growth-row [row]="i + 3" [widget]="this">
          <tr [ngClass]="{'light-grey-line': (i % 2 !== 0)}">
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaSpaceType}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaArea | rdLocalizedNumber:0}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaMarketRent | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaMeasure}}</widget-value>
            </td>
            <td colspan="5">
              <widget-value [align]="'left'">{{entry.usMlaRentEscalations}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaLeaseType}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaLeaseTerm | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaFreeRent | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaEffectiveRent | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaTiShell | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaTiNew | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaTiRenew | rdLocalizedNumber:2}}</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaRenewalProbability * 100 | rdLocalizedNumber:2}} %</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaLcNew * 100 | rdLocalizedNumber:2}} %</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaLcRenewal * 100 | rdLocalizedNumber:2}} %</widget-value>
            </td>
            <td colspan="4">
              <widget-value [align]="'left'">{{entry.usMlaMonthsDowntime | rdLocalizedNumber:0}}</widget-value>
            </td>
          </tr>
        </dynamic-growth-row>
      </ng-container>
    </tbody>
  </table>
</div>
